const merge = require('lodash/merge')

const config = {
  all: {
    env:
      window.RUNTIME_CONFIG?.NODE_ENV || process.env.NODE_ENV || 'development',
    isDev:
      window.RUNTIME_CONFIG?.NODE_ENV || process.env.NODE_ENV !== 'production',
    basename: window.RUNTIME_CONFIG?.PUBLIC_URL || process.env.PUBLIC_URL,
    systemName:
      window.RUNTIME_CONFIG?.REACT_APP_SYSTEM_NAME ||
      process.env.REACT_APP_SYSTEM_NAME,
    isBrowser: typeof window !== 'undefined',
    vimcTaiLieuUrl:
      window.RUNTIME_CONFIG?.REACT_APP_VIMC_TAI_LIEU_URL ||
      process.env.REACT_APP_VIMC_TAI_LIEU_URL,
    envName:
      window.RUNTIME_CONFIG?.REACT_APP_ENV_NAME ||
      process.env.REACT_APP_ENV_NAME,
    useSSO:
      window.RUNTIME_CONFIG?.REACT_APP_USE_SSO === 'true' ||
      process.env.REACT_APP_USE_SSO,
    prefix:
      window.RUNTIME_CONFIG?.REACT_APP_PREFIX || process.env.REACT_APP_PREFIX,
    version:
      window.RUNTIME_CONFIG?.REACT_APP_VERSION || process.env.REACT_APP_VERSION,
    chatbotUrl:
      window.RUNTIME_CONFIG?.REACT_APP_CHATBOT_URL ||
      process.env.REACT_APP_CHATBOT_URL,
  },
  test: {},
  development: {
    apiUrl:
      window.RUNTIME_CONFIG?.REACT_APP_API_URL || process.env.REACT_APP_API_URL,
    apiUrlTruc:
      window.RUNTIME_CONFIG?.REACT_APP_API_URL_TRUC ||
      process.env.REACT_APP_API_URL_TRUC,
    apiUrlCommonService:
      window.RUNTIME_CONFIG?.REACT_APP_API_URL_COMMON_SERVICE ||
      process.env.REACT_APP_API_URL_COMMON_SERVICE,
    apiConvertOfficeUrl:
      window.RUNTIME_CONFIG?.REACT_APP_API_CONVERT_DOCUMENT_TO_PDF_URL ||
      process.env.REACT_APP_API_CONVERT_DOCUMENT_TO_PDF_URL,
    oauth: {
      clientId:
        window.RUNTIME_CONFIG?.REACT_APP_OAUTH_CLIENT_ID ||
        process.env.REACT_APP_OAUTH_CLIENT_ID,
      clientSecret:
        window.RUNTIME_CONFIG?.REACT_APP_OAUTH_CLIENT_SECRET ||
        process.env.REACT_APP_OAUTH_CLIENT_SECRET,
    },
    oauthTruc: {
      clientId:
        window.RUNTIME_CONFIG?.REACT_APP_OAUTH_TRUC_CLIENT_ID ||
        process.env.REACT_APP_OAUTH_TRUC_CLIENT_ID,
      clientSecret:
        window.RUNTIME_CONFIG?.REACT_APP_OAUTH_TRUC_CLIENT_SECRET ||
        process.env.REACT_APP_OAUTH_TRUC_CLIENT_SECRET,
    },
    notificationURL:
      window.RUNTIME_CONFIG?.REACT_APP_NOTIFICATION_URL ||
      process.env.REACT_APP_NOTIFICATION_URL,
    lowDisplay:
      window.RUNTIME_CONFIG?.REACT_APP_LOW_DISPLAY ||
      process.env.REACT_APP_LOW_DISPLAY,
    vapidKey:
      window.RUNTIME_CONFIG?.REACT_APP_VAPIKEY || process.env.REACT_APP_VAPIKEY,
    notifyEnv:
      window.RUNTIME_CONFIG?.REACT_APP_NOTIFY_ENV ||
      process.env.REACT_APP_NOTIFY_ENV,
  },
  production: {
    apiUrl:
      window.RUNTIME_CONFIG?.REACT_APP_API_URL || process.env.REACT_APP_API_URL,
    apiUrlTruc:
      window.RUNTIME_CONFIG?.REACT_APP_API_URL_TRUC ||
      process.env.REACT_APP_API_URL_TRUC,
    apiUrlCommonService:
      window.RUNTIME_CONFIG?.REACT_APP_API_URL_COMMON_SERVICE ||
      process.env.REACT_APP_API_URL_COMMON_SERVICE,
    apiConvertOfficeUrl:
      window.RUNTIME_CONFIG?.REACT_APP_API_CONVERT_DOCUMENT_TO_PDF_URL ||
      process.env.REACT_APP_API_CONVERT_DOCUMENT_TO_PDF_URL,
    oauth: {
      clientId:
        window.RUNTIME_CONFIG?.REACT_APP_OAUTH_CLIENT_ID ||
        process.env.REACT_APP_OAUTH_CLIENT_ID,
      clientSecret:
        window.RUNTIME_CONFIG?.REACT_APP_OAUTH_CLIENT_SECRET ||
        process.env.REACT_APP_OAUTH_CLIENT_SECRET,
    },
    oauthTruc: {
      clientId:
        window.RUNTIME_CONFIG?.REACT_APP_OAUTH_TRUC_CLIENT_ID ||
        process.env.REACT_APP_OAUTH_TRUC_CLIENT_ID,
      clientSecret:
        window.RUNTIME_CONFIG?.REACT_APP_OAUTH_TRUC_CLIENT_SECRET ||
        process.env.REACT_APP_OAUTH_TRUC_CLIENT_SECRET,
    },
    notificationURL:
      window.RUNTIME_CONFIG?.REACT_APP_NOTIFICATION_URL ||
      process.env.REACT_APP_NOTIFICATION_URL,
    lowDisplay:
      window.RUNTIME_CONFIG?.REACT_APP_LOW_DISPLAY ||
      process.env.REACT_APP_LOW_DISPLAY,
    vapidKey:
      window.RUNTIME_CONFIG?.REACT_APP_VAPIKEY || process.env.REACT_APP_VAPIKEY,
    notifyEnv:
      window.RUNTIME_CONFIG?.REACT_APP_NOTIFY_ENV ||
      process.env.REACT_APP_NOTIFY_ENV,
  },
}

module.exports = merge(config.all, config[config.all.env])
